export default __webpack_public_path__ + "static/media/radish-1.4de4f530.svg";